import { render } from "./EditShippingMethod.vue?vue&type=template&id=c22f99b6&scoped=true&ts=true"
import script from "./EditShippingMethod.vue?vue&type=script&lang=ts"
export * from "./EditShippingMethod.vue?vue&type=script&lang=ts"

import "./EditShippingMethod.vue?vue&type=style&index=0&id=c22f99b6&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22f99b6"]])

export default __exports__